/**
 * Common UI utilities.
 *
 * ``cn()`` is the shadcn/ui convention for merging class lists —
 * combines ``clsx`` (conditional class concatenation) with
 * ``tailwind-merge`` (de-duplicates conflicting Tailwind utility
 * classes so later overrides win). Every shadcn component depends
 * on this helper; keep the signature stable.
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
